export default __webpack_public_path__ + "static/media/parking_signal_lg.10e85762.jpg";